import React from 'react'
import Card from './Card'

const MobileAbout = () => {

   const data = [
    {
        title: "PEPE THE ADVENTUROUS FROG COIN",
        text: "Pepe the Frog Coin explores the crypto universe, bridging communities on Binance Smart Chain and Polygon. Join Pepe's quest to revolutionize digital assets with blockchain connectivity.",
    },
    {
        title: "THE MULTICHAIN MEME TOKEN",
        text: "Pepe Coin, a multichain meme token on Ethereum, BNB Chain, and Polygon, invites you to join a vibrant community of enthusiasts. Experience the interconnected world of meme magic.",
    },
    {
        title: "LAUNCH IN 3 STELLAR CHAINS",
        text: "Pepe Coin unites the crypto meme community on three blockchains. Pepe aims to trend on every DEX and CEX, bringing a multichain dimension to meme tokens.",
    },
    {
        title: "PEPE'S GALACTIC EXPEDITION",
        text: "Pepe the Frog Coin is an odyssey through cryptocurrency, exploring blockchain technology. Pepe bridges multiple chains, fostering innovation and a global crypto community.",
    },
];
    
  return (
   <div className="w-full h-full relative flex justify-center items-center p-4">
      <div className="w-full gap-4 grid grid-cols-1">
        <div className="flex justify-center items-center mb-10">
            <h1 className=" text-4xl text-slate-100 font-bold uppercase tracking-wider mt-10">
            About
          </h1>
        </div>
        {data.map(({ title, text }, index) => (
          <Card title={title} text={text} key={`About-Card-${index}`} />
        ))}
      </div>
    </div>
  )
}

export default MobileAbout
